module.exports = __webpack_public_path__ + "img/service_voice_atm.6b63d99e.svg";